module.exports = __webpack_public_path__ + "img/btn_go.505e5f3a.png";